import React from 'react'

import utils from '../../utils'
import fetch from '../fetch'
import { Modal } from 'antd'

const DataGrid = {
    selections: [],
    refresh: function () {

    }
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelect = (ids) => {
    DataGrid.selections = ids
}

/**
 * @method setRefresh
 * @param {function} callback
 * @return {promise}
 */
const setRefresh = (callback) => {
    DataGrid.refresh = callback
}

const getSelection = () => {
    return DataGrid.selections
}

const prefixUrl = 'teacher/thesis/comprehensive'

const columns = utils.columns([
    {
        key: '$index',
        label: '序号',
        width: 75
    },
    {
        key: 'studentNo',
        label: '学号',
        width: 75
    },
    {
        key: 'studentName',
        label: '学生姓名',
        width: 75
    }, {
        key: 'orgName',
        label: '学生所属部门',
        width: 100
    }, {
        key: 'title',
        label: '论文题目',
        width: 75
    }, {
        key: 'employeeCode',
        label: '指导教师工号',
        width: 100
    }, {
        key: 'employeeName',
        label: '指导教师姓名',
        width: 100
    }, {
        key: 'inspectType',
        label: '检查类别',
        width: 75
    }, {
        key: 'inspectName',
        label: '检查人姓名',
        width: 75
    }, {
        key: 'inspectResult',
        label: '检查结果',
        width: 75
    }, {
        key: 'termName',
        label: '所属学期',
        width: 75
    }
])

const querySearch = (keywords = { pageNum: 1, pageSize: 100 }) => {
    return fetch.post(`${prefixUrl}/query?pageNum=${keywords.pageNum}&pageSize=${keywords.pageSize}&order=${keywords.order || ''}&sort=${keywords.sort || ''}`, keywords)
        .then(res => {
            const data = res.payload.data
            return Object.assign({
                result: data.dataList,
                selects: data.dataList.map(e => {
                    return {
                        value: e.id,
                        checked: false,
                    }
                }),
                checked: false,
                total: data.total,
                pageIndex: data.pageNum,
                pageSize: data.pageSize,
                notify: ([]).length ? '' : '暂无数据...'
            })
        })
}

//删除信息
const remove = (ids) => {
    return fetch.post(`${prefixUrl}/remove`, ids)
        .then(res => {
            if (res.code === 200) {
                return res.payload.data
            }
        })
}
const batchRemove = () => {
    if (DataGrid.selections.length === 0) {
        Modal.error({
            title: '请先选择一项或多项！',
            content: '只有勾选一项或多项后才能删除！',
        })
    } else {
        Modal.confirm({
            title: '确定删除该记录？',
            content: '删除后将无法恢复！',
            onOk() {
                remove(DataGrid.selections)
                    .then(response => {
                        if (response.code === 200) {
                            Modal.success({
                                title: '提示信息',
                                content: (
                                    <div>
                                        <p>{response.message}</p>
                                    </div>
                                ),
                                okText: "确认",
                                onOk() {
                                    DataGrid.selections = []
                                    DataGrid.selectData = []
                                    DataGrid.refresh()
                                },
                            })
                        }
                    })
            },
            onCancel() { },
            okText: "确认",
            cancelText: "取消"
        })
    }
}
//修改信息

const querySearchById = (id) => {

    return fetch.post(`${prefixUrl}/get`, id)
        .then(response => response.payload.data)
        .catch(error => {
        })
}
const update = (data) => {
    return fetch.post(`${prefixUrl}/update`, data)
        .then(response => {
            return response
        })
}
export default {
    onSelect,
    setRefresh,
    getSelection,
    columns,
    querySearch,
    remove,
    batchRemove,
    querySearchById,
    update
}